import { Table } from '@tanstack/react-table'
import { Col, Input, Row } from 'reactstrap'
import Paginator from '../../Common/UIPagination'
import TablePageSize from './TablePageSize'

interface PaginationBarProps<TData> {
    table: Table<TData>
    totalItems?: number
    hasPageSizeSelect?: boolean
}

const PAGE_SIZE_OPTIONS = [20, 50, 100]

const PaginationBar = <TData,>(props: PaginationBarProps<TData>) => {
    const { table, totalItems, hasPageSizeSelect } = props
    
    const pageCount = table.getPageCount()
    const { pageIndex, pageSize } = table.getState().pagination

    if (pageCount <= 0) return null

    return (
        <Row className="justify-content-md-between align-items-md-center p-2 flex-column flex-md-row">
            <TablePageSize
                table={table}
                totalItems={totalItems}
                className="col-md-auto mb-2 fs-13 fw-light"
            />
            <Col className="d-flex align-center col-auto">
                <div className="d-flex flex-wrap align-items-center">
                    {hasPageSizeSelect && (
                        <div className="me-4 mb-2">
                            <Input
                                type="select"
                                className="form-control"
                                value={pageSize}
                                onChange={(e) => {
                                    table.setPageSize(Number(e.target.value))
                                    table.setPageIndex(0)
                                }}
                            >
                                {PAGE_SIZE_OPTIONS.map((size) => (
                                    <option value={size} key={size}>
                                        {size}
                                    </option>
                                ))}
                            </Input>
                        </div>
                    )}
                    {pageCount > 1 && (
                        <Paginator
                            currentPage={pageIndex + 1}
                            totalPages={pageCount}
                            onPageChange={(page: number) => table.setPageIndex(page - 1)}
                        />
                    )}
                </div>
            </Col>
        </Row>
    )
}

export default PaginationBar
